import { useCareerCenterFetch } from "@/modules/careerCenter/hooks/useCareerCenterFetch"
import { useCompanyTrack } from "@/modules/companies/client/hooks/tracking/useCompanyTrack"
import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"

type CompanyFollowTrackFunction = (follow: boolean) => void

export const useCompanyFollowTrack = (): CompanyFollowTrackFunction => {
  const companyTrack = useCompanyTrack()
  const { dataCompany } = useCompanyFetch()
  const { dataCareerCenter } = useCareerCenterFetch()

  return (follow: boolean) =>
    companyTrack("company_page_follow_action", {
      action: follow ? "follow" : "unfollow",
      company_page_id: dataCompany?.id,
      context: "company_page",
      ...(dataCareerCenter?.intranet && { school_id: dataCareerCenter?.id }),
    })
}
